<div class="patient">
  <div class="wrapper">
    

    <!-- ========================== header (start) ========================== -->
    <header class="l-header">
      <div class="on-mobile header-logo">
        <img src="assets/icons/logo.svg" alt="Artisan Sonics" />
      </div>
      <div class="l-header-panel">
        <div style="display: flex; align-items: center">
          <h1 class="t-title-main" style="width: 20vw; white-space: nowrap;">
           Biopsy and Polypectomy Stats for Colonoscopy
          </h1>
          <div class="l-flex l-flex-c t-field t-field-pad" style="margin-left: 2em; white-space: nowrap;">
            <label> Type of Report </label>

            <i class="t-sep"></i>

            <select
              class="t-field t-select"
              [(ngModel)]="report"
            >
              <option value="" selected disabled>Select Report Type</option>
              <option value="biopsy">Biopsy count</option>
              <option value="biopsy_only">Biopsy only count (no polypectomy)</option>
              <option value="polypectomy">Polypectomy count</option>
              <option value="polypectomy_only">Polypectomy only count (no biopsy)</option>
              <option value="polypectomy_with_biopsy">Polypectomy and/or Biopsy count</option>
              <option value="both">Both Biopsy and Polypectomy count</option>
              <option value="detailed_report">Detailed Report - All Exams</option>
            </select>
          </div>
        </div>
        
        <span style="white-space: nowrap; display: flex; align-items: center; gap: 0.5em;">
          <label>From</label>
          <input
            [matDatepicker]="startDatepicker"
            [(ngModel)]="startdate"
            [max]="enddate"
            class="t-field t-field--date menstural-field"
            aria-labelledby="menstural_LMP"
            (click)="startDatepicker.open()"
          />
          <mat-datepicker #startDatepicker></mat-datepicker>
          <label>Until</label>
          <input
            [matDatepicker]="endDatepicker"
            [(ngModel)]="enddate"
            [min]="startdate"
            (click)="endDatepicker.open()"
            class="t-field t-field--date menstural-field"
            aria-labelledby="menstural_LMP"
          />
          <mat-datepicker #endDatepicker></mat-datepicker>
        </span>
        
        <button 
          class="search-btn search-btn--newPatient" 
          (click)="getReport()"
          [disabled]="!report || !startdate || !enddate"
          matTooltip="Search"
          style="margin-left: 1em;width: fit-content;"
        >
          Search
        </button>
        
        <nav class="on-mobile header-mobilePanel">
          <button
            class="btn-mobileMenu"
            id="open-mainNav"
            data-show=".l-sidebar"
            aria-label="open mobile sidebar"
          ></button>
        </nav>
        
        <img
          style="cursor: pointer; position: absolute; right: 6em"
          matTooltip="Download Excel"
          *ngIf="results && results.length"
          height="31em"
          src="../../assets/icons/file.svg"
          (click)="exportToExcel()"
        />
        
        <nav class="header-menu" style="padding-right: initial;">
          <a routerLink="/patsearch" class="header-menu-link icon-confirm" matTooltip="Exit Biopsy Stats"></a>
        </nav>
      </div>
    </header>

     <main class="l-deashboard">
       <!-- Loading Spinner -->
       <app-loading-spinner *ngIf="isLoading"></app-loading-spinner>
       
       
       
       <!-- Doctor and HMO Filters for detailed_report -->
       <div *ngIf="!isLoading && report === 'detailed_report' && results && results.length > 0" 
            style="margin-bottom: 1em; display: flex; align-items: center; gap: 1em; flex-wrap: wrap;">
         <div style="display: flex; align-items: center; gap: 0.5em;">
           <label style="font-weight: bold;">Filter by Doctor:</label>
           <select class="t-field t-select" [(ngModel)]="selectedDoctor" style="width: 250px;">
             <option value="All">All Doctors</option>
             <option *ngFor="let doctor of getUniqueDoctors()" [value]="doctor">
               {{doctor}}
             </option>
           </select>
         </div>
         <div style="display: flex; align-items: center; gap: 0.5em;">
           <label style="font-weight: bold;">Filter by HMO:</label>
           <select class="t-field t-select" [(ngModel)]="selectedHMO" style="width: 200px;">
             <option value="All">All HMOs</option>
             <option *ngFor="let hmo of getUniqueHMOs()" [value]="hmo">
               {{hmo}}
             </option>
           </select>
         </div>
         <span style="color: #666; font-size: 0.9em;">
           Showing {{getFilteredResults().length}} of {{results.length}} exams
         </span>
       </div>
       
       <table *ngIf="!isLoading && results && results.length > 0" class="l-table-auto table-bordered stats-table">
        <thead>
          <tr class="l-row weightAss-thead">
            <ng-container *ngFor="let param of getParams()">
                <th class="l-th-m table-cell-bordered" 
                    [style.cursor]="param === 'ExamDate' ? 'pointer' : 'default'"
                    (click)="param === 'ExamDate' && sortByDate()">
                  {{param}}
                  <span *ngIf="param === 'ExamDate'">
                    {{ sortDirection === 'asc' ? '▲' : '▼' }}
                  </span>
                </th>
            </ng-container>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let res of getFilteredResults(); let i = index" 
              class="l-row weightAss-tbody table-row-bordered"
              [ngClass]="{'total-row': res.DoctorName?.includes('Total')}">
            <ng-container *ngFor="let param of getParams()">
              <td class="l-td-m table-cell-bordered" 
                  [ngClass]="{'bold-cell': res.DoctorName?.includes('Total')}">
                <ng-container *ngIf="param === 'ExamDate'; else normalCell">
                  {{res[param] | date:'dd/MM/yyyy HH:mm'}}
                </ng-container>
                <ng-template #normalCell>
                  <ng-container *ngIf="param === 'HMO'; else otherFields">
                    {{res[param] || ''}}
                  </ng-container>
                  <ng-template #otherFields>
                    {{res[param] !== null && res[param] !== undefined ? res[param] : '-'}}
                  </ng-template>
                </ng-template>
              </td>
            </ng-container>
          </tr>
          <!-- Summary Row for detailed_report -->
          <tr *ngIf="report === 'detailed_report' && getSummaryRow()" 
              class="l-row weightAss-tbody table-row-bordered" 
              style="background-color: #f0f0f0; font-weight: bold;">
            <ng-container *ngFor="let param of getParams()">
              <td class="l-td-m table-cell-bordered">
                {{getSummaryRow()[param]}}
              </td>
            </ng-container>
          </tr>
        </tbody>
       </table>
     </main>

    <aside class="l-sidebar l-flex l-column">
      <img class="off-mobile sidebar-logo" src="assets/icons/logo.svg" alt="Artisan Sonics" />

      <!-- user panel (start) -->
      <div class="userPanel">
        <div class="search-patient">       
            <div class="w100">
              <button class="search-btn clickable"
                matTooltip="Patients"
                routerLink="/patsearch"
              >
                Go Back to Patients
              </button>
            </div>
        
        </div>

        
      </div>
      <!-- user panel (end) -->

      <!-- main nav (start) -->
      <nav class="mainNav l-fg1 scroller"></nav>
      <!-- main nav (end) -->
      <app-docpanel></app-docpanel>
    </aside>

    <!-- ========================== main sidebar (end) ========================== -->

    <app-bottombar></app-bottombar>
    </div>
</div>